import React, { useMemo } from "react";
import { BsDot } from "react-icons/bs";
import a1 from "../../../../assets/stat/a1.png";
import a2 from "../../../../assets/stat/a2.png";
import a3 from "../../../../assets/stat/a3.png";
import geotraffic from "../../../../assets/stat/geotraffic.jpg";

const Section6 = () => {
  const feature = useMemo(
    () => [
      {
        icon: a1,
        title: "Comprehensive Insights",
        des: "Analyze agent performance and optimize workflow with deep analytics.",
      },
      {
        icon: a2,
        title: "Real-time Validation",
        des: "Verifies responses instantly and enables seamless page navigation.",
      },
      {
        icon: a3,
        title: "Prospect Capture",
        des: "Receive customized emails once visitors complete the form.",
      },
      {
        icon: geotraffic,
        title: "Monitor Bot Traffic Worldwide",
        des: "Global breakdown of bot interactions and engagement.",
      },
    ],
    []
  );

  return (
    <section className="flex flex-col w-full text-lg sm:text-xl 2xl:text-2xl space-y-8 mt-12 px-4 sm:px-10">
      {/* Header */}
      <div className="flex flex-col gap-4">
        <div className="border border-lightprimary px-3 py-1 rounded-xl flex items-center w-fit bg-white shadow-sm">
          <BsDot className="w-6 h-6 fill-primary" />
          <span className="font-semibold text-sm sm:text-base">Features</span>
        </div>

        <h2 className="text-3xl sm:text-4xl 2xl:text-5xl font-bold leading-snug text-darkprimary">
          Build the Perfect Customer-Facing AI Chatbot
        </h2>

        <p className="text-gray-700 text-lg sm:text-xl 2xl:text-2xl max-w-4xl">
          Jaano.ai gives you all the tools you need to train your perfect AI
          chatbot and connect it to your website.
        </p>
      </div>

      {/* Feature List */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {feature.map(({ icon, title, des }, index) => (
          <div
            key={index}
            className="flex flex-col bg-black text-white rounded-2xl overflow-hidden shadow-md transition-transform hover:scale-[1.02]">
            <img
              src={icon}
              alt={title}
              className="w-full aspect-[1.91/1] object-cover"
            />

            <div className="p-4 space-y-2">
              <h5 className="font-semibold text-lightprimary">{title}</h5>
              <p className="text-gray-300 text-sm sm:text-base">{des}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Section6;
